@if (initialNavigationSettled()) {
  <router-outlet />
} @else {
  <div class="startup-loader" role="status" aria-live="polite" aria-label="Loading CTAT">
    <div class="startup-loader__card">
      <div class="startup-loader__brand" aria-hidden="true">
        <svg
          class="startup-loader__logo"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="207.29 368.34 343.41 343.41"
          width="48"
          height="48"
          focusable="false"
        >
          <path fill="#00D699" d="M207.29,368.34v163.1c90.15,0,163.12-72.96,163.12-163.1H207.29z" />
          <path fill="#FF72FC" d="M387.61,368.34v163.1c90.13,0,163.09-72.96,163.09-163.1H387.61z" />
          <path fill="#FFAE00" d="M207.29,548.65v163.1c90.15,0,163.12-72.96,163.12-163.1H207.29z" />
          <path fill="#FE793F" d="M387.61,548.65v163.1c90.13,0,163.09-72.96,163.09-163.1H387.61z" />
        </svg>
        <span class="startup-loader__title">CTAT</span>
      </div>
      <div class="startup-loader__spinner" aria-hidden="true"></div>
      <p class="startup-loader__message">Loading application…</p>
    </div>
  </div>
}
